import React, { useEffect, useState, useMemo } from "react";
import { Col, Form, Row } from "react-bootstrap";
import SecBTN from "../../../UI/SecBTN";
import TableHeader from "./Header";
import Pagination from "./Pagination";
import Search from "./Search";
import classes from "./Table.module.css";
import Modals from "../../../UI/Modals/Modals";
import Input from "../../../UI/Input/Input";
import Toast from "../../../UI/Toast/Toast";

const DataTable = (props) => {
  const x = JSON.parse(localStorage.getItem("user"));
  const [showEntries, setShowEntries] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = +showEntries;

  const headers = [
    { name: "S.No.", field: "id", sortable: false },
    { name: "Sub-Topic Name", field: "subTopicName", sortable: true },
    { name: "Sub-Topic Sequence", field: "subTopicSequence", sortable: false },
    { name: "Action", field: "action", sortable: false },
    { name: "Sub-Status", field: "status", sortable: false },
  ];

  const commentsData = useMemo(() => {
    //let computedComments = comments;
    let computedComments = props.data;

    if (search) {
      computedComments = computedComments.filter((comment) =>
        comment.Sub_topic_name.toLowerCase().includes(search.toLowerCase())
      );
    }
    setTotalItems(computedComments.length);

    //Sorting comments
    if (sorting.field) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [props.data,currentPage, search, sorting, ITEMS_PER_PAGE]);
//functions other than table
const [dataToModal,setDataToModal] = useState({
    "sub_topic_name": "",
    "sub_topic_id": null,
    "user_id": +x?.data?.user?.user_id,
    "sub_topic_sequence": null,
    "status":null
})
const [index,setIndex] = useState(null)
const [showPopUp,setShowPopUp] = useState(false)
  const onSaveHandler = () => {
    props.updateHandler(dataToModal);
    // toast.success("Changes Saved Successfully.")
    setShowPopUp(false)
  };
  const hideHandler = () => {
    setShowPopUp(false)
  };
  const editHandler = (sub_topic_id,sub_topic_name, sub_topic_sequence,status,is_printed) => {
    setDataToModal((prev) => {
      return {
        ...prev,
        sub_topic_id: sub_topic_id,
        sub_topic_name: sub_topic_name,
        sub_topic_sequence: sub_topic_sequence,
        status: status,
        is_printed:is_printed,
      };
    });
    setShowPopUp(true)
    setIndex(index)
  };

  return (
    <>
      <Toast />
        <Modals show={showPopUp} onHide={hideHandler}>
          <Row className="g-3">
            <h5>Edit Sub-topic</h5>
            <Col sm={12}>
              <Form.Label>Sub-topic Name :</Form.Label>
              <Input
                value={dataToModal.sub_topic_name}
                type="text"
                placeholder="Enter Subtopic Name"
                onChange={(e) => setDataToModal(prev=>{
                  return {...prev,"sub_topic_name": e.target.value}
                })}
              />
            </Col>
            <Col sm={12}>
              <Form.Label>Sub-topic Sequence :</Form.Label>
              <Input
                value={dataToModal.sub_topic_sequence}
                type="number"
                placeholder="Enter Subtopic Sequence"
                onChange={(e) => setDataToModal(prev=>{
                  return {...prev,"sub_topic_sequence": e.target.value}
                })}
              />
            </Col>
          </Row>
          <div className="text-center mt-5 mb-3">
            <SecBTN className="sec-btn1" onClick={onSaveHandler}>
              Save Changes
            </SecBTN>
          </div>
        </Modals>
      {props.data.length == 0 ? (
        props.noDataShow ? (
          <p>No data Found !!</p>
        ) : (
          <p>Please Select {props.sub == '' ?  "Subject" : "Topic"}!!</p>
        )
      ) : (
        <>
          <div className="d-flex justify-content-between">
            <div>
              Show{" "}
              <select
                onChange={(e) => {
                  setShowEntries(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="30">30</option>
                <option value="50">50</option>
              </select>{" "}
              enteries
            </div>
            <Search
              onSearch={(value) => {
                setSearch(value);
                setCurrentPage(1);
              }}
            />
          </div>
          <div className="table-responsive">
            <table className="table table-bordered mt-3 mb-0">
              <TableHeader
                className={classes.header}
                headers={headers}
                onSorting={(field, order) => setSorting({ field, order })}
              />
              <tbody>
                {commentsData.map((data) => (
                  <tr key={data.sub_topic_id}>
                    <th scope="row">{data.index}</th>
                    <td>{data.Sub_topic_name}</td>
                    <td>{data.sub_topic_sequence}</td>
                    <td>
                      <SecBTN
                        className="sec-btn"
                        style={{ padding: "0.3rem 1rem", fontSize: "0.8rem" }}
                        onClick={() =>
                          editHandler( data.sub_topic_id,data.Sub_topic_name, data.sub_topic_sequence,data.status,data.is_printed)
                        }
                      >
                        Edit
                      </SecBTN>
                    </td>
                    <td>
                      <SecBTN
                        onClick={() =>
                          props.activationHandler(data.status, data.sub_topic_id)
                        }
                        className="sec-btn1"
                        style={{ padding: "0.4rem 1rem", fontSize: "0.8rem" }}
                      >
                        {data.status == "1" ? "Active" : "In-active"}
                      </SecBTN>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <p className="small ">
            Showing{" "}
            <b>
              {+showEntries < props.data.length
                ? +showEntries
                : props.data.length}
            </b>{" "}
            out of {props.data.length} enteries
          </p>
          <div className="mt-4">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        </>
      )}
    </>
  );
};

export default DataTable;
